import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';

import { FaviconService } from './core/service/favicon.service';
import { getBrand, getBrandFaviconDataUri } from './core/utils/brand';
import { InstallBannerComponent } from './shared/components/install-banner/install-banner';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, InstallBannerComponent],
  templateUrl: './app.html',
  styleUrl: './app.css',
})
export class AppComponent {
  private readonly favicon = inject(FaviconService);
  private readonly brand = getBrand();

  constructor() {
    // apple-itunes-app is baked statically per-brand at build time by
    // scripts/split-brand-index.mjs (see index.html / works/index.html)
    // instead of being set here via Meta.updateTag(), since Apple's App Clip
    // verifier and Smart App Banner discovery read the raw HTML without
    // executing JS.

    // index.html ships a static igloohome-colored favicon so there's an icon
    // before JS boots; replace it here so the tab always matches the active
    // brand instead of staying igloohome-teal on iglooworks hosts.
    this.favicon.setFavicon(getBrandFaviconDataUri(this.brand));
  }
}
